import breakpoints from 'styles/themes/default/breakpoints';
import configuration from './configuration';
import generateMediaQueryBreakpoints from './generateMediaQueryBreakpoints';
import generateMediaRules from './generateMediaRules';

const mqBreakpoints = generateMediaQueryBreakpoints(configuration, breakpoints);
const medias = generateMediaRules(mqBreakpoints);

export default medias;
